import React, { useState } from 'react';
import { Add_Talk_Group_Modal_Chat } from '../../../ChatComponent/ModalChat/Add_Talk_Group_Modal_Chat';
import { ChatConversation } from '../../../ChatConversation/ChatConversation';
import { ModalConversation } from '../../../ChatConversation/ModalConversation';
import './sass/styles.sass';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

export const FooterComponent = () => {

    const [chatConvesation, setChatConversation] = useState(false)
    return (

        <>

            {/* <ModalConversation/> */}


            <div className='c-footer'>
                <NavLink className='c-footer-copyright' style={{ marginRight: 10 }} to={{ pathname: `/remision`, state: { state: 'cotizacionesGuardadas' } }}>REMISION Link</NavLink>
                <NavLink className='c-footer-copyright' style={{ marginRight: 10 }} to={{ pathname: `/shipment`, state: { state: 'cotizacionesGuardadas' } }}>ENVIOS Link</NavLink>
                <NavLink className='c-footer-copyright' style={{ marginRight: 10 }} to={{ pathname: `/reception`, state: { state: 'cotizacionesGuardadas' } }}>RECEPCION Link</NavLink>
                <NavLink className='c-footer-copyright' style={{ marginRight: 10 }} to={{ pathname: `/shopping`, state: { state: 'cotizacionesGuardadas' } }}>COMPRAS Link</NavLink>

                <h3 className='c-footer-copyright'> © Copyright TSI 2020 - Todos los derechos reservados TSI 2020 </h3>
            </div>

        </>

    )
}
